import script from "./TalkToTheBookV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./TalkToTheBookV1.vue?vue&type=script&setup=true&lang=ts"

import "./TalkToTheBookV1.vue?vue&type=style&index=0&id=5cfedab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfedab0"]])

export default __exports__